export const within48Hours = date => {
  const now = new Date();
  if (date < now) {
    return true;
  }
  const diffInMilliseconds = Math.abs(now - date);
  const diffInHours = diffInMilliseconds / 1000 / 60 / 60;
  return diffInHours <= 48;
};
